import { Card, ScrollArea, Stack, Text } from "@mantine/core";

interface RenderErrorProps {
    error?: unknown;
}
export function RenderError({ error }: RenderErrorProps) {
    if (error) {
        return (
            <Stack align="center">
                <Card maw="60vw" padding="md">
                    <Card.Section inheritPadding py="xs" withBorder>
                        <h1>Something went wrong</h1>
                        <h3>
                            {error instanceof Error
                                ? error.message
                                : // oxlint-disable-next-line typescript/no-base-to-string
                                  String(error)}
                        </h3>
                    </Card.Section>
                    {error instanceof Error && (
                        <Card.Section inheritPadding mt="sm">
                            <ScrollArea>
                                <Text c="blue.4" component="pre">
                                    {error.stack}
                                </Text>
                            </ScrollArea>
                        </Card.Section>
                    )}
                </Card>
            </Stack>
        );
    }
}
